module.exports = __webpack_public_path__ + "static/media/Acores.aab40a0a.svg";